export default __webpack_public_path__ + "b1305b863a95bdaf630c30120a0b1203.svg";